import g from '#core/global';
import load from '#core/load';
import util from '#core/util';


const clipboard_content_attr = 'data-clipboard-content';
const clipboard_selector_attr = 'data-clipboard-selector';
const clipboard_button_$ = `[${clipboard_content_attr}], [${clipboard_selector_attr}]`;

let has_clipboard_button = false;
let $clipboard_buttons = null;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('clipboard')) return false;

		load.content(() => {
			has_clipboard_button = assign_elements();
			if (!has_clipboard_button) return false;
		});
		load.all(() => {
			has_clipboard_button = assign_elements();
			if (!has_clipboard_button) return false;
		});
	},

};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_clipboard_button) return true;

	$clipboard_buttons = document.querySelectorAll(clipboard_button_$);
	if (!$clipboard_buttons.length) return false;

	$clipboard_buttons.forEach($clipboard_button => {
		$clipboard_button.addEventListener(g.click_e, e => {
			e.preventDefault();
			copy_html($clipboard_button);
		});
	});

	return true;
}


/**
 * Copy HTML content to clipboard
 * @param {HTMLElement} $button
 */
function copy_html($button) {
	const selector = $button.getAttribute(clipboard_selector_attr);
	let content;

	if (selector) {
		if (!util.isValidSelector(selector)) return;
		const $target = document.querySelector(selector);
		if (!$target) return;
		content = $target.textContent || '';
	} else {
		content = $button.getAttribute(clipboard_content_attr);
	}

	if (!content) return;

	copy_text(content)
		.then(() => {
			$button.setAttribute(g.is_active_attr, g.true_s);
			setTimeout(() => {
				$button.setAttribute(g.is_active_attr, g.false_s);
			}, 2000);
		})
		.catch(err => {
			console.error('Failed to copy: ', err);
		})
	;
}


/**
 * Copy text to clipboard with fallback for non-secure contexts
 * @param {string} text
 * @return {Promise}
 */
function copy_text(text) {
	if (navigator.clipboard) {
		return navigator.clipboard.writeText(text);
	}
	
	const $textarea = document.createElement('textarea');
	$textarea.value = text;
	$textarea.style.position = 'fixed';
	$textarea.style.opacity = '0';
	document.body.appendChild($textarea);
	$textarea.select();
	try {
		document.execCommand('copy');
		document.body.removeChild($textarea);
		return Promise.resolve();
	} catch (err) {
		document.body.removeChild($textarea);
		return Promise.reject(err);
	}
}
